/**
 * Trusted-by client logos.
 *
 * All logos are pre-processed transparent PNGs at /public/logos/*.png —
 * bg-removed via border-strip median sampling, auto-cropped, and
 * DOWNSCALED to 800px height max (never upscaled — that was making
 * low-res sources look blurry). Adding a logo:
 *   1. Append here with the slug matching the file in /public/logos/
 *   2. Add the source URL in the pipeline script
 *   3. Re-run `python3 backend/scripts/process_client_logos.py`
 *
 * At >14 unique entries, TrustedBy.jsx auto-splits into 2 rows moving in
 * opposite directions. Duplicates by lowercased name are stripped at render.
 */
export const CLIENT_LOGOS = [
  // ---------- Row 1 (top): global tech + big-brand enterprise ----------
  { name: "Google", logo: "/logos/google.png" },
  { name: "Amazon", logo: "/logos/amazon.png" },
  { name: "Flipkart", logo: "/logos/flipkart.png" },
  { name: "Autodesk", logo: "/logos/autodesk.png" },
  { name: "Swiggy", logo: "/logos/swiggy.png" },
  { name: "Zomato", logo: "/logos/zomato.png" },
  { name: "Scopely", logo: "/logos/scopely.png" },
  { name: "Ola Electric", logo: "/logos/ola-electric.png" },
  { name: "MPL", logo: "/logos/mpl.png" },
  { name: "Universal", logo: "/logos/universal.png" },
  { name: "Hindustan Coca-Cola Beverages", logo: "/logos/hindustan-coca-cola.png" },
  { name: "Tata Consultancy Services", logo: "/logos/tcs.png" },
  { name: "IDFC First Bank", logo: "/logos/idfc-first-bank.png" },
  { name: "Adani Defence and Aerospace", logo: "/logos/adani-defence-and-aerospace.png" },
  { name: "Karnataka ITBT", logo: "/logos/karnataka-itbt.png" },
  { name: "Quantiphi", logo: "/logos/quantiphi.png" },
  { name: "Bahwan CyberTek", logo: "/logos/bahwan-cybertek.png" },
  { name: "Darwinbox", logo: "/logos/darwinbox.png" },
  { name: "Chubb", logo: "/logos/chubb.png" },

  // ---------- Row 2 (bottom): D2C, lifestyle, media, creators ----------
  { name: "GIVA", logo: "/logos/giva.png" },
  { name: "ONNME by GIVA", logo: "/logos/onnme-by-giva.png" },
  { name: "Heer by GIVA", logo: "/logos/heer-by-giva.png" },
  { name: "SUGAR Cosmetics", logo: "/logos/sugar-cosmetics.png" },
  { name: "TrulyMadly", logo: "/logos/trulymadly.png" },
  { name: "Marzi by Primus", logo: "/logos/marzi-by-primus.png" },
  { name: "Plum", logo: "/logos/plum.png" },
  { name: "Linen Club", logo: "/logos/linen-club.png" },
  { name: "mCaffeine", logo: "/logos/mcaffeine.png" },
  { name: "Earthful", logo: "/logos/earthful.png" },
  { name: "Durex", logo: "/logos/durex.png" },
  { name: "Brigade", logo: "/logos/brigade.png" },
  { name: "Heritage", logo: "/logos/heritage.png" },
  { name: "Humans of Bombay", logo: "/logos/humans-of-bombay.png" },
  { name: "Nature inFocus", logo: "/logos/nature-in-focus.png" },
  { name: "HDFW", logo: "/logos/hdfw.png" },
  { name: "Zebu Animation Studios", logo: "/logos/zebu-animation-studios.png" },
  { name: "UMO Design", logo: "/logos/umo-design.png" },
  { name: "UX India", logo: "/logos/ux-india.png" },
  { name: "Bullet", logo: "/logos/bullet.png" },
];
